"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTrue = exports.hasCookiePermission = exports.REQUIRED_COOKIE_NAME = exports.PERFORMANCE_COOKIE_NAME = exports.MARKETING_COOKIE_NAME = exports.FUNCTIONAL_COOKIE_NAME = exports.CookieProvider = exports.CookieContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _webVitals = require("web-vitals");
var _utils = require("../pwa-kit/utils/utils");
var _useConfig = require("../hooks/useConfig");
var _TagManager = _interopRequireDefault(require("../utils/TagManager"));
var _pwaKit = require("../pwa-kit");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // @ts-ignore
const REQUIRED_COOKIE_NAME = exports.REQUIRED_COOKIE_NAME = 'RequiredAllowed';
const FUNCTIONAL_COOKIE_NAME = exports.FUNCTIONAL_COOKIE_NAME = 'FuncionalAllowed';
const PERFORMANCE_COOKIE_NAME = exports.PERFORMANCE_COOKIE_NAME = 'PerformanceAllowed';
const MARKETING_COOKIE_NAME = exports.MARKETING_COOKIE_NAME = 'MarketingAllowed';
const CookieContext = exports.CookieContext = /*#__PURE__*/(0, _react.createContext)({
  isConfirmed: false,
  isFunctionalAllowed: false,
  isPerformanceAllowed: false,
  isMarketingAllowed: false,
  isModalOpen: false,
  showDetails: false,
  setCookiesAllowed: () => {},
  setCookieModal: () => {},
  eventTracking: () => {},
  getCookieFlags: () => {}
});
const hasCookiePermission = cookieName => {
  return _jsCookie.default.get(cookieName) === 'true';
};
exports.hasCookiePermission = hasCookiePermission;
const isTrue = val => {
  return typeof val === 'boolean' ? val === true : val === 'true';
};
exports.isTrue = isTrue;
const sendEvents = (...events) => {
  // @ts-ignore
  const dataLayer = window.dataLayer || [];
  if (events[0] && events[0].ecommerce) {
    // @ts-ignore
    dataLayer.push({
      ecommerce: null
    });
  }
  dataLayer.push(...events);
  // @ts-ignore
  window.dataLayer = dataLayer;
};
const CookieProvider = ({
  children,
  gtmId
}) => {
  const {
    cookiePrefix,
    gtmDomain
  } = (0, _useConfig.useConfig)();
  const {
    updateDnt
  } = (0, _pwaKit.useDNT)();
  const [isCookieModalOpen, setCookieModalOpen] = (0, _react.useState)(false);
  const [isDetailsOpen, setIsDetailsOpen] = (0, _react.useState)(false);
  const [isFunctionalAllowed, setIsFunctionalAllowed] = (0, _react.useState)(false);
  const [isPerformanceAllowed, setIsPerformanceAllowed] = (0, _react.useState)(false);
  const [isMarketingAllowed, setIsMarketingAllowed] = (0, _react.useState)(false);
  const [isConfirmed, setIsConfirmed] = (0, _react.useState)(true);
  const requiredCookieName = `${cookiePrefix}${REQUIRED_COOKIE_NAME}`;
  const functionalCookieName = `${cookiePrefix}${FUNCTIONAL_COOKIE_NAME}`;
  const performanceCookieName = `${cookiePrefix}${PERFORMANCE_COOKIE_NAME}`;
  const marketingCookieName = `${cookiePrefix}${MARKETING_COOKIE_NAME}`;
  const initializeTracker = () => {
    _TagManager.default.initialize({
      gtmId: gtmId,
      dataLayer: {
        originalLocation: `${location.protocol}//${location.hostname}${location.pathname}${location.search}`
      },
      domain: gtmDomain
    });
  };
  const pushToDataLayer = data => {
    _TagManager.default.dataLayer({
      dataLayer: {
        event: 'coreWebVitals',
        webVitalsMeasurement: {
          name: data === null || data === void 0 ? void 0 : data.name,
          id: data === null || data === void 0 ? void 0 : data.id,
          value: data === null || data === void 0 ? void 0 : data.value,
          delta: data === null || data === void 0 ? void 0 : data.delta,
          valueRounded: Math.round(data === null || data === void 0 ? void 0 : data.value),
          deltaRounded: Math.round(data === null || data === void 0 ? void 0 : data.delta)
        }
      }
    });
  };
  const initializeWebVitals = () => {
    (0, _webVitals.onCLS)(pushToDataLayer);
    (0, _webVitals.onFID)(pushToDataLayer);
    (0, _webVitals.onLCP)(pushToDataLayer);
  };
  (0, _react.useEffect)(() => {
    initializeTracker();
    initializeWebVitals();
    setIsConfirmed(isTrue(_jsCookie.default.get(requiredCookieName) || 'false'));
    setIsFunctionalAllowed(isTrue(_jsCookie.default.get(functionalCookieName) || 'false'));
    setIsPerformanceAllowed(isTrue(_jsCookie.default.get(performanceCookieName) || 'false'));
    const isMarketingAllowed = isTrue(_jsCookie.default.get(marketingCookieName) || 'false');
    setIsMarketingAllowed(isMarketingAllowed);
    updateDnt(!isMarketingAllowed);
  }, []);
  const setCookieAndState = (cookieName, value, setState) => {
    _jsCookie.default.set(cookieName, value, {
      sameSite: 'strict',
      expires: 365
    });
    setState(value);
  };
  const setConfirmed = (val = false) => {
    setCookieAndState(requiredCookieName, val, setIsConfirmed);
  };
  const setFunctionalAllowed = (val = false) => {
    setCookieAndState(functionalCookieName, val, setIsFunctionalAllowed);
  };
  const setPerformanceAllowed = (val = false) => {
    setCookieAndState(performanceCookieName, val, setIsPerformanceAllowed);
  };
  const setMarketingAllowed = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(function* (val = false) {
      setCookieAndState(marketingCookieName, val, setIsMarketingAllowed);
      yield updateDnt(!val);
    });
    return function setMarketingAllowed() {
      return _ref.apply(this, arguments);
    };
  }();
  const setCookiesAllowed = values => {
    let options = [];
    if (typeof values === 'string') {
      options = values.split(',').map(option => option.trim());
    } else if (typeof values === 'object') {
      options = Object.keys(values).filter(key => values[key]);
    }
    const required = true;
    const functional = options.includes('functional');
    const performance = options.includes('statistics') || options.includes('performance');
    const marketing = options.includes('marketing');
    sendEvents({
      event: isConfirmed ? 'consent_updated' : 'consent_given',
      consent_functional: functional,
      consent_lb: performance,
      consent_marketing: marketing
    });
    setConfirmed(required);
    setFunctionalAllowed(functional);
    setPerformanceAllowed(performance);
    setMarketingAllowed(marketing);
    setCookieModalOpen(false);
  };
  const handleCookieModal = (isOpen, showDetails) => {
    setCookieModalOpen(isOpen);
    setIsDetailsOpen(showDetails);
  };
  const setCookieModal = (isOpen, showDetails) => handleCookieModal(isOpen, showDetails);
  const eventTracking = (eventName, eventData) => {
    if (_utils.isServer) return;
    try {
      sendEvents(_objectSpread({
        event: eventName
      }, eventData));
    } catch (e) {
      //TODO: we need a logger
    }
  };
  let initialFunctionalCookieAllowed = false;
  let initialPerformanceCookieAllowed = false;
  let initialMarketingCookieAllowed = false;
  if (!_utils.isServer) {
    initialFunctionalCookieAllowed = _jsCookie.default.get(functionalCookieName) === undefined ? false : isFunctionalAllowed;
    initialPerformanceCookieAllowed = _jsCookie.default.get(performanceCookieName) === undefined ? false : isPerformanceAllowed;
    initialMarketingCookieAllowed = _jsCookie.default.get(marketingCookieName) === undefined ? false : isMarketingAllowed;
  }
  const getCookieFlags = () => {
    if (_utils.isServer) return {};
    return {
      isFunctionalAllowed: isTrue(_jsCookie.default.get(functionalCookieName) || 'false'),
      isPerformanceAllowed: isTrue(_jsCookie.default.get(performanceCookieName) || 'false'),
      isMarketingAllowed: isTrue(_jsCookie.default.get(marketingCookieName) || 'false')
    };
  };
  return /*#__PURE__*/_react.default.createElement(CookieContext.Provider, {
    value: {
      isConfirmed,
      isFunctionalAllowed,
      isPerformanceAllowed,
      isMarketingAllowed,
      setCookiesAllowed,
      setCookieModal,
      isModalOpen: isCookieModalOpen,
      showDetails: isDetailsOpen,
      eventTracking: eventTracking,
      getCookieFlags: getCookieFlags
    }
  }, children);
};
exports.CookieProvider = CookieProvider;